const userJourneys = {
    PASSWORD: 'password',
    PASSWORDLESS: 'passwordless',
    MAGIC_LINK: 'magicLink',
};

export default userJourneys;
